import React from "react";
import { FENOMENO_TIPOS_CATALOGO } from "./fenomenosTipoConfig";
import EvtTipoTabLabel from "./EvtTipoTabLabel";

export default function EvtFenomenosTipoTabs({
  value,
  onChange,
  items = FENOMENO_TIPOS_CATALOGO,
}) {
  if (!items.length) return null;

  const isSingle = items.length === 1;
  const isOddCount = !isSingle && items.length % 2 === 1;

  return (
    <div
      className={`evt-efectos-tabs evt-efectos-tabs--param evt-efectos-tabs--fen${
        isSingle ? " is-single-tab" : ""
      }${items.length >= 2 ? " is-many-tabs" : ""}${
        isOddCount ? " is-odd-count" : ""
      }`}
      role="tablist"
      aria-label="Fenómeno asociado"
    >
      {items.map((item, index) => {
        const isActive = value === item.label;

        return (
          <React.Fragment key={item.label}>
            {index > 0 ? (
              <span className="evt-efectos-tab-divider" aria-hidden="true" />
            ) : null}
            <button
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`evt-efectos-tab${isActive ? " is-active" : ""}`}
              onClick={() => onChange(item.label)}
            >
              <span className="evt-efectos-tab__icon-wrap" aria-hidden="true">
                <img className="evt-efectos-tab__icon" src={item.icon} alt="" />
              </span>
              <EvtTipoTabLabel label={item.label} forceSingleLine={isSingle} />
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
